module.exports = __webpack_public_path__ + "static/media/sent.ff941a79.svg";